export default __webpack_public_path__ + "static/media/bnr2.a5ca003a.jpg";